export default __webpack_public_path__ + "static/media/forestly-noexpl-base_EN.be938a02.png";